var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TheNavbar'),_c('div',{staticClass:"split"},[_c('div',{staticStyle:{"width":"400px"},attrs:{"id":"split-0"}},[_c('SimpleBar',{staticClass:"p-3 search-input-wrapper"},[_c('TheSearchInput')],1)],1),_c('div',{attrs:{"id":"split-1"}},[_c('TheVisualizer',{staticClass:"m-3"})],1)]),_c('TheWarningModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }